<template>
  <div v-if="bookRecord">
    <!--<span style="display:none">{{heartBeat}}</span>-->
    <!-- {{bookRecord}} -->
    <div v-bind:class="{ active: (selectedBook === book) }" class="blockRange row clickable"><span v-on:click="selectBook(book)"><template v-if="!bookRecord.title"><div class="animated-background"></div></template><template v-else>{{bookRecord.title.length > 20 ? bookRecord.title.substring(0, 20) + '...' : bookRecord.title}}</template> (<template v-if="bookRecord.hits">{{bookRecord.hits}}/</template>{{bookRecord.noOfpages}} {{$t(fieldsMapping[bookRecord.source].unit)}})<br/></span>    
      <template v-if="bookRecord && bookRecord.url">
        <template v-if="bookRecord.url !== urlRewrite(bookRecord.url,bookRecord.source)">
          <span v-if="'XAsia' in fieldsMapping[bookRecord.source]" v-tooltip="$t('goToXBook')"><a target="_blank" class='xAsia' :href="bookRecord.url.startsWith('http') ? bookRecord.url : `http://${bookRecord.url}`"><icon name="book"></icon></a></span>
          </template>
          <span v-if="'original' in fieldsMapping[bookRecord.source]" v-tooltip="$t('goToBook')"><a target="_blank" :href='urlRewrite(bookRecord.url,bookRecord.source)' :class='(["itr-sbb-digital", "itr-ead-digital", "itr-buddhist-road", "itr-dtab"].indexOf(book[2]) > -1 ? "open": ["itr-maoistlegacy-db"].indexOf(book[2]) > -1 ? "openButLoginRequired" : "")'><icon name="book"></icon></a>
          </span>      
      </template>
      <template v-if='bookRecord.databaseurl && !bookRecord.url'>
        <span v-tooltip="$t('goToXDatabase')"><a target="_blank" class='xAsia' :href='bookRecord.databaseurl'><icon name="database"></icon></a></span>
        <span v-if="'original' in fieldsMapping[bookRecord.source]" v-tooltip="$t('goToDatabase')"><a target="_blank" :class='(["itr-sbb-digital", "itr-ead-digital", "itr-buddhist-road", "itr-dtab"].indexOf(book[2]) > -1 ? "open": ["itr-maoistlegacy-db"].indexOf(book[2]) > -1 ? "openButLoginRequired" : "")' :href='urlRewrite(bookRecord.databaseurl,bookRecord.source)'><icon name="database"></icon>a</a></span>
      </template>
      <template v-if='(bookRecord.databaseurl || "").length === 0 &&  (bookRecord.url || "").length === 0'>
        <template v-if="(fieldsMapping[bookRecord.source]['XAsia'] || '').length > 0">
          <span v-tooltip="$t('goToXDatabase')"><a target="_blank" class='xAsia' :href="fieldsMapping[bookRecord.source]['XAsia'].startsWith('http') ? fieldsMapping[bookRecord.source]['XAsia'] : `http://${fieldsMapping[bookRecord.source]['XAsia']}`"><icon name="database"></icon></a></span>
        </template>
        <template v-if="(fieldsMapping[bookRecord.source]['original'] || '').length > 0">
          <span v-if="'original' in fieldsMapping[bookRecord.source]" v-tooltip="$t('goToDatabase')"><a target="_blank" :class='(["itr-sbb-digital", "itr-ead-digital", "itr-buddhist-road", "itr-dtab"].indexOf(book[2]) > -1 ? "open": ["itr-maoistlegacy-db"].indexOf(book[2]) > -1 ? "openButLoginRequired" : "")' :href='fieldsMapping[bookRecord.source]["original"]'><icon name="database"></icon></a></span>
        </template>
      </template>
      <template v-if='(bookRecord.opacurl || "").length > 0'>
        <span v-tooltip="$t('goToOPAC')"><a target="_blank" class='open' :href='bookRecord.opacurl'><icon name="book"></icon></a></span>
      </template>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import 'vue-awesome/icons/book'
import 'vue-awesome/icons/database'
import Icon from 'vue-awesome/components/Icon'
// import Tooltip from 'vue-directive-tooltip'
// import 'vue-directive-tooltip/css/index.css'
// import "~vue-directive-tooltip/dist/vueDirectiveTooltip.css"

import AsyncComputed from 'vue-async-computed'
import solrQuery from '../assets/solrQuery'

import setting from 'crossasia-itr-fulltextsearch-setting'

const fieldsMapping = setting.fieldsMapping
const sources = setting.sources

// Vue.use(Tooltip)
Vue.use(AsyncComputed)

Vue.component('icon', Icon)

// Fetch the solr fields and fulltext based on the defined fields mapping.
export default {
  components: {
    Icon
  },
  name: 'block2',
  props: ['book'],
  asyncComputed: {
    bookRecord: async function () {
      let vm = this
      // …console.log(this.book)
      let _obj = await solrQuery.fetchBookMetaDataById(vm, this.book[2], this.book[0])
      // console.log(_obj)
      _obj.response.docs[0].source = this.book[2]
      _obj.response.docs[0].hits = this.book[1]
      return JSON.parse(JSON.stringify(_obj.response.docs[0]))
    }
  },
  computed: {
    selectedBook: function () {
      return this.$store.getters['collections/getSelectedBook']
    }
  },
  data: function () {
    return {
      fieldsMapping: fieldsMapping,
      sources: sources
    }
  },
  methods: {
    urlRewrite: function (url, source) {
      if (Array.isArray(url)) {
        url = url[0]
      }
      let fieldsMap = this.fieldsMapping[source]
      if (Array.isArray(fieldsMap.XAsia)) {
        url = fieldsMap.XAsia.reduce((acc, x) => {
          return acc.replaceAll(x, fieldsMap.original)
        }, url)
      } else {
        url = url.replaceAll(fieldsMap.XAsia, fieldsMap.original)
      }
      // console.log(fieldsMap.XAsia, fieldsMap.original)

      if (fieldsMap.https) {
        url = url.replaceAll(/^http:/g, 'https:')
      }
      // book.url.replace(fieldsMap[book.source].XAsia,fieldsMap[book.source].original)
      return url
    },
    // checkURL : function(url) {
    //   url = url.startsWith('http') ? url : `http://${url}`
    //   if (fieldsMap.https) {
    //     url = url.replaceAll(/^http:/, 'https:')
    //   }
    // },
    selectBook: function (book) {
      this.$store.dispatch('collections/setSelectedBook', {selectedBook: book})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

/*a {*/
/*  color: #42b983;*/
/*}*/

div.blockRange {
  margin-top:1em;
  padding-left: 15px !important
}
div.row {
  font-size: small;
}
div.active {
  color:#b41815 !important;;
  background-color: #ddd;
}

div.clickable {
  cursor: pointer !important;
}

.fa-icon {
  width: 1em;
  height: 1em; /* or any other relative font sizes */

  /* You would have to include the following two lines to make this work in Safari */
  max-width: 100%;
  max-height: 100%;
}

a.open {
 color: green !important;
 padding-right: 0.5em;
}

a.openButLoginRequired {
 color: orange !important;
 padding-right: 0.5em;
}

a.xAsia {
 color: #b41815 !important;
 padding-right: 0.5em;
}

a {
  color: #9D9D9D;
}

@keyframes placeHolderShimmer{
    0%{
        background-position: -468px 0
    }
    100%{
        background-position: 468px 0
    }
}

.animated-background {
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: #f6f7f8;
    background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
    background-size: 800px 104px;
    height: 1em;
    position: relative;
}
.background-masker {
    background: #fff;
    position: absolute;
}
.background-masker.header-left {
    top: 0;
    left: 40px;
    right: 0;
    height: 1em;
}

div.active {
	position: relative;
	/*background: #88b7d5;*/
	border: 4px solid #ddd;
}
div.active:after, div.active:before {
	left: 100%;
	top: 50%;
	border: solid transparent;
	content: " ";
	height: 0;
	width: 0;
	position: absolute;
	pointer-events: none;
}

div.active:after {
	border-color: rgba(136, 183, 213, 0);
	border-left-color: #ddd;
	border-width: 15px;
	margin-top: -15px;
}
div.active:before {
	border-color: rgba(194, 225, 245, 0);
	border-left-color: #ddd;
	/*border-width: 36px;*/
	/*margin-top: -36px;*/
}
</style>



// WEBPACK FOOTER //
// src/components/Block.vue